import React, { FC } from 'react'
import { Container, OldHeading } from '@gassan-ui'

type MembershipPageTitleProps = {
  children?: React.ReactNode
  title: string
}

export const MembershipPageTitle: FC<MembershipPageTitleProps> = ({ children, title }) => {
  return (
    <Container className="py-10 md:py-16 xl:py-24">
      <OldHeading variant="hXl" as="h2" textAlign="center">
        {title}
      </OldHeading>
      {children && children}
    </Container>
  )
}
